import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.apiBaseUrl
});

// Attach Authorization header from localStorage on every request
api.interceptors.request.use((req) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      req.headers['Authorization'] = `Bearer ${token}`;
    } else {
      if (req.headers && 'Authorization' in req.headers) {
        delete req.headers['Authorization'];
      }
    }
  } catch {}
  return req;
});

export default api;
